// components
import { ToggleButton, ToggleButtonGroup } from '@mui/material';

// hooks
import { useTranslation } from 'react-i18next';

// stores
import { useCalendarStore } from 'components/mrp/stores/calendarStore/calendarStore';
import { useShallow } from 'zustand/shallow';

// utils
import { getFormattedTimeStep } from './CalendarSteps.utils';

const TIME_STEP_OPTIONS = [15, 30, 60, 180];

const CalendarSteps = () => {
  const { t } = useTranslation('common', { keyPrefix: 'mrp' });
  const { timeStep, setTimeStep } = useCalendarStore(
    useShallow((state) => ({
      timeStep: state.timeStep,
      setTimeStep: state.control.setTimeStep
    }))
  );

  const handleTimeStepChange = (
    _event: React.MouseEvent<HTMLElement>,
    timeStep: number
  ) => {
    timeStep && setTimeStep(timeStep);
  };

  return (
    <ToggleButtonGroup
      aria-label="calendar steps"
      exclusive
      fullWidth
      onChange={handleTimeStepChange}
      orientation="vertical"
      size="small"
      value={timeStep}
    >
      {TIME_STEP_OPTIONS.map((step) => (
        <ToggleButton
          key={step}
          value={step}
          aria-label={`${t('calendarTimeStep')} ${step}m`}
        >
          {getFormattedTimeStep(step)}
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  );
};

export default CalendarSteps;
